<template>
    <v-container>
        <v-row dense>
            <v-col v-for="( item, i) in reportsByRol" :key="i" cols="12" md="6" sm="6">
                <v-card :color="item.color" dark @click="item.onClick">
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="text-h5 font-weight-bold text-h5" v-text="item.titulo">
                            </v-card-title>
                            <v-card-subtitle v-text="item.subtitulo">
                            </v-card-subtitle>
                            <!-- <v-card-actions>
                                <v-btn class="ml-2 mt-3" fab icon height="20px"  right width="40px">
                                    <v-icon class="mr-2" large>fas fa-file-excel</v-icon>
                                </v-btn>
                            </v-card-actions> -->
                        </div>
                        <v-avatar class="ma-3" size="125" tile>
                            <v-icon x-large>{{item.icon}}</v-icon>
                        </v-avatar>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <ExcelExportVenta :dialog.sync="dialogExcelExport" :handleModal="handleExcelExport"
        :tipo-salida.sync="tipoSalida" :sucursales.sync="sucursales" :clients.sync="clients" :is-admin="isAdmin"
        show-service-report show-detail-report
        v-if="dialogExcelExport"/>
        
        <ExportSellByProductCategoryMix :dialog.sync="dialogSellByProductCategoryMix" :handleModal="handleSellByProductCategoryMix"
        :tipo-salida.sync="tipoSalida" :sucursales.sync="sucursales" :clients.sync="clients" :is-admin="isAdmin"
        v-if="dialogSellByProductCategoryMix"/>

        <ExcelExportSellDebts :dialog.sync="dialogExcelSellDebtExport" :handleModal="handleExcelSellDebtExport"
        :sucursales.sync="sucursales" :clients.sync="clients"
        :is-admin="isAdmin" v-if="dialogExcelSellDebtExport"/>

        <ExportAccountStatement :dialog.sync="dialogExportAccountStatement" :handleModal="handleExportAccountStatement"
        :sucursales.sync="sucursales" :clients.sync="clients"
        :is-admin="isAdmin" v-if="dialogExportAccountStatement"/>

        <ExcelExportEntryDetail :dialog.sync="dialogExcelEntryDetailExport" :handleModal="handleExcelEntryDetailExport"
        :typeEntry.sync="tipoEntrada" :providers.sync="proveedores"
        :brands.sync="sucursales" :is-admin="isAdmin" v-if="dialogExcelEntryDetailExport"/>
        <ExcelExportAsistencia :dialog.sync="dialogExcelAssistant" :handleModal="handleExcelAssistant" v-if="dialogExcelAssistant"/>

        <ExcelExportSellProfit :dialog.sync="dialogExcelSellProfitExport" :handleModal="handleExcelSellProfitExport"
        :sucursales.sync="sucursales" :is-admin="isAdmin" v-if="dialogExcelSellProfitExport"/>
    </v-container>

</template>
<script>
import TipoSalidaDataService from '@/service/venta/TipoSalidaDataService';
import ExcelExportVenta from '../venta/ExcelExportVenta.vue';
import ExcelExportSellDebts from '../venta/ExcelExportSellDebts.vue';
import ExcelExportEntryDetail from '../entrada/ExcelExportEntryDetail.vue';
import tipoPagoDataService from '@/service/catalogo/tipoPago/tipoPagoDataService';
import sucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import usuarioDataService from '@/service/usuario/UsuarioDataService';
import TipoEntradaService from '@/service/entrada/TipoEntradaService';
import ProveedorDataService from '@/service/catalogo/proveedor/proveedorDataService';
import ExcelExportAsistencia from '../asistenciaPersonal/ExcelExportAsistencia.vue';
import ExcelExportSellProfit from '../venta/ExcelExportSellProfit.vue';
import clienteDataService from '@/service/cliente/clienteDataService';
import ExportSellByProductCategoryMix from '../venta/ExportSellByProductCategoryMix.vue';
import ExportAccountStatement from '../venta/ExportAccountStatement.vue';
import { can, CAP } from '@/service/permiso/capacidades';

export default {
    name: 'Reportes',
    components: {
        ExcelExportVenta, ExcelExportSellDebts, ExcelExportEntryDetail, ExcelExportAsistencia,
        ExcelExportSellProfit, ExportSellByProductCategoryMix, ExportAccountStatement
    },
    created() {
        this.getAllTipoSalida();
        this.getAllTipoPago();
        this.getAllSucursal();
        this.getAllTipoEntrada();
        this.getProveedores();
        this.getClients();
    },
    data() {
        return {
            tipoSalida: [],
            tipoPagos: [],
            sucursales: [],
            dialogExcelExport: false,
            dialogExcelSellDebtExport: false,

            dialogExcelEntryDetailExport: false,
            tipoEntrada: [],
            proveedores: [],
            clients: [],

            dialogExcelAssistant: false,
            dialogExcelSellProfitExport: false,
            dialogSellByProductCategoryMix: false,
            dialogExportAccountStatement: false,
            reportes: [
                {  id: 1,
                    color: 'indigo darken-1', titulo: 'Reporte de entradas',
                    subtitulo: 'Ingresos granja San Fernando',
                    icon: 'fas fa-exchange-alt',
                    onClick: () => this.handleExcelEntryDetailExport()
                },
                {   id: 2,
                    color: 'green darken-3', titulo: 'Reporte de ventas',
                    subtitulo: 'Reporte de Ventas San Fernando',
                    icon: 'fas fa-file-invoice-dollar',
                    onClick: () => this.handleExcelExport()
                },
                {   id: 3,
                    color: 'deep-purple lighten-1', titulo : 'Reporte de productividad',
                    subtitulo: 'Productividad San Fernando',
                    icon: 'fas fa-chart-line',
                    onClick: () => this.handleExcelSellProfitExport()
                },
                {   id: 4,
                    color: 'red darken-1', titulo: 'Reporte de creditos pendientes',
                    subtitulo: 'Cobranza San Fernando',
                    icon: 'fas fa-money-check-alt',
                    onClick: () => this.handleExcelSellDebtExport()
                },
                {   id: 6,
                    color: 'blue darken-1', titulo: 'Reporte de asistencia',
                    subtitulo: 'Asistencia de personal',
                    icon: 'fas fa-user-clock',
                    onClick: () => this.handleExcelAssistant()
                },
                {   id: 7,
                    color: 'blue-grey darken-2', titulo: 'Reporte de venta general',
                    subtitulo: 'Reporte permite filtrar por categoria y producto',
                    icon: 'fas fa-file-invoice-dollar',
                    onClick: () => this.handleSellByProductCategoryMix()
                },
                {   id: 5,
                    color: 'green darken-4', titulo: 'Reporte de Estado de cuenta',
                    subtitulo: 'Estado de cuenta San Fernando',
                    icon: 'fas fa-file-invoice-dollar',
                    onClick: () => this.handleExportAccountStatement()
                },
                
            ],
        }
    },
    methods: {
        handleExcelExport() { this.dialogExcelExport = !this.dialogExcelExport },
        handleExcelSellDebtExport() { this.dialogExcelSellDebtExport = !this.dialogExcelSellDebtExport },
        handleExcelEntryDetailExport() { this.dialogExcelEntryDetailExport = !this.dialogExcelEntryDetailExport },
        handleExcelAssistant() { this.dialogExcelAssistant = !this.dialogExcelAssistant },
        handleExcelSellProfitExport() { this.dialogExcelSellProfitExport = !this.dialogExcelSellProfitExport },
        handleSellByProductCategoryMix() { this.dialogSellByProductCategoryMix = !this.dialogSellByProductCategoryMix },
        handleExportAccountStatement() { this.dialogExportAccountStatement = !this.dialogExportAccountStatement },
        async getAllTipoSalida(){ this.tipoSalida = await TipoSalidaDataService.getAllTipoSalida().then( resp => resp.data ) || [] },
        async getAllTipoPago(){ this.tipoPagos = await tipoPagoDataService.allTipoPago().then( rsp => rsp.data ) || []},
        async getAllSucursal(){ this.sucursales = await sucursalDataService.lstSucursal().then( resp => resp.data ) || [] },
        async getAllTipoEntrada(){ this.tipoEntrada = await TipoEntradaService.getAllTipoEntrada().then( rsp => rsp.data ) || [];},
        async getProveedores(){ this.proveedores = await ProveedorDataService.allProveedor().then( rsp => rsp.data ) || []; },
        async getClients(){ this.clients = await clienteDataService.getAll().then( rsp => rsp.data ) || []; }
    },
    computed: {
        roles(){
            return usuarioDataService.getUserRoles();
        },
        isAdmin(){ return can(CAP.ADMIN, this.roles); },
        reportsByRol(){
            // El reporte de productividad (id 3) es el unico que se excluye por
            // rol. Se concede si el usuario tiene CUALQUIER rol que lo
            // permite, no solo si el primero de su lista lo es.
            const hasPermission = can(CAP.REPORTE_PRODUCTIVIDAD_VER, this.roles);

            return this.reportes.filter(report => hasPermission || report.id !== 3);
        }
    }
}
</script>